import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/ideas/detailImage';
import classNames from 'classnames';
import Img from 'react-image';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import { IIdea } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
  isSp: boolean;
};

const DetailImage: React.FC<ComponentProps> = ({ idea, isSp }) => {
  const { title, mainImage, mainImageL } = idea.fields;
  const classes = useStyles();
  const imageSrc = () => {
    if (isSp) {
      return `${mainImageL?.fields.file.url}?fm=webp&fit=pad&w=800`;
    } else {
      return `${mainImage.fields.file.url}?fm=webp`;
    }
  };
  const Load = () => <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />;

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <Img
          src={imageSrc()}
          loader={<Load />}
          className={classNames(classes.img, classes.imgRaised, classes.imgRounded)}
          alt={title}
        />
      </div>
    </div>
  );
};

export default DetailImage;
